
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcp",
      function () {
        return require("private-next-pages/uxcp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcp"])
      });
    }
  